export class Scales {
    public jobId: string;
    public graphMaxYScale: number;
    public heatScale: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.jobId = json.jobId;
            this.graphMaxYScale = json.graphMaxYScale;
            this.heatScale = json.heatScale;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/scales.ts